export const copyTextToClipboard = ({ text, onCopyError, onCopySuccess, }) => {
    navigator.clipboard.writeText(text).then(onCopySuccess).catch(onCopyError);
};
